/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';

export default class Article extends Model {
	isAvailable() {
		return Model.attribute<boolean>('isAvailable').call(this);
	}

	productId() {
		return Model.attribute<string>('productId').call(this);
	}

	isbn() {
		return Model.attribute<string>('isbn').call(this);
	}

	ean() {
		return Model.attribute<string>('ean').call(this);
	}

	title() {
		return Model.attribute<string>('title').call(this);
	}

	subtitle() {
		return Model.attribute<string>('subtitle').call(this);
	}

	description() {
		return Model.attribute<string>('description').call(this);
	}

	language() {
		return Model.attribute<string>('language').call(this);
	}

	author() {
		return Model.attribute<string>('author').call(this);
	}

	slug() {
		return Model.attribute<string>('slug').call(this);
	}

	pages() {
		return Model.attribute<number>('pages').call(this);
	}

	coverImage() {
		return Model.attribute<string>('coverImage').call(this);
	}

	publisher() {
		return Model.attribute<string>('publisher').call(this);
	}

	category() {
		return Model.attribute<string>('category').call(this);
	}

	serie() {
		return Model.attribute<string>('serie').call(this);
	}

	type() {
		return Model.attribute<string>('type').call(this);
	}

	publishedAt() {
		return Model.attribute<string>('publishedAt').call(this);
	}

	shopLink() {
		return Model.attribute<string>('shopLink').call(this);
	}

	literaryWorkId() {
		return Model.attribute<number>('literaryWorkId').call(this);
	}
}
